import React, { useState } from 'react';
import '../css/Navbar.css';
import logo from "../assets/2look-logo.png";
import NCNlogo from "../assets/NCN-Logo black.png";
import { useNavigate, Link } from 'react-router-dom';

const megaMenuData = {
  Electronics: {
    icon: "⚡",
    columns: [
      { title: "COMPUTERS", items: ["Laptops", "Desktops", "Computer Components", "Network Equipment", "Peripherals","Handheld Devices"] },
      { title: "GAMING", items: ["Consoles", "Games", "Gaming Laptops", "Gaming Peripherals"] },
      { title: "PHONES", items: ["iPhone","Smartphone Android", "Smart Watches","Phone Accessories", "Headphones", "Speakers", "Accessories"] },
      { title: "Photo & Video", items: ["Photo & Video Cameras","Photo Accessories", "Full Frame"] },
      { title: "TV & Audio", items: ["TVs","Oled TV", "Wi-Fi"] }
    ]
  },
  Appliances: {
    icon: "📺",
    columns: [
      { title: "LARGE APPLIANCES", items: ["Refrigerators", "Washing Machines", "Air Conditioners", "Televisions"] },
      { title: "KITCHEN APPLIANCES", items: ["Microwaves", "Mixer Grinders", "Water Purifiers", "Electric Kettles"] }
    ]
  },
  "Home & Garden": {
    icon: "🏡",
    columns: [
      { title: "FURNITURE", items: ["Beds & Mattresses", "Sofas & Recliners", "Dining Tables", "Study Tables"] },
      { title: "HOME DECOR", items: ["Wall Arts", "Clocks", "Vases & Flowers", "Lighting & Lamps"] }
    ]
  },
  "Baby & Kids": {
    icon: "🧸",
    columns: [
      { title: "BABY CARE", items: ["Diapers & Wipes", "Baby Bath & Skin", "Baby Food & Formula"] },
      { title: "TOYS & CLOTHES", items: ["Toys & Games", "Infant Clothing", "Kids Footwear"] }
    ]
  },
  "Beauty & Care": {
    icon: "💄",
    columns: [
      { title: "MAKEUP & SKIN", items: ["Face Makeup", "Lipsticks", "Moisturizers", "Sunscreen"] },
      { title: "PERSONAL CARE", items: ["Haircare & Shampoos", "Trimmers & Shavers", "Fragrances & Deos"] }
    ]
  }
};

const Navbar = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerTab, setDrawerTab] = useState('categories');
  const [expandedMobileCat, setExpandedMobileCat] = useState(null);

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDept, setSelectedDept] = useState('All Departments');
  const [mobileSearchQuery, setMobileSearchQuery] = useState('');

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
    setExpandedMobileCat(null);
  };

  const handleSearch = () => {
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery)}&department=${encodeURIComponent(selectedDept)}`);
    }
  };

  const handleMobileSearch = () => {
    if (mobileSearchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(mobileSearchQuery)}&department=All Departments`);
      toggleDrawer();
    }
  };

  return (
    <header className="mp-header">
      {isDrawerOpen && <div className="mp-drawer-overlay" onClick={toggleDrawer}></div>}
      
      <div className={`mp-mobile-drawer ${isDrawerOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <input 
            type="text" 
            placeholder="Search for products" 
            className="drawer-search" 
            value={mobileSearchQuery}
            onChange={(e) => setMobileSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleMobileSearch()}
          />
          <button className="drawer-close" onClick={toggleDrawer}>✕</button>
        </div>
        
        <div className="drawer-tabs">
          <button className={`tab-btn ${drawerTab === 'categories' ? 'active' : ''}`} onClick={() => setDrawerTab('categories')}>CATEGORIES</button>
          <button className={`tab-btn ${drawerTab === 'menu' ? 'active' : ''}`} onClick={() => setDrawerTab('menu')}>MENU</button>
        </div>

        <div className="drawer-content">
          {drawerTab === 'categories' ? (
            <div className="mobile-categories-list">
              {Object.keys(megaMenuData).map((catKey) => {
                const catData = megaMenuData[catKey];
                const isExpanded = expandedMobileCat === catKey;
                return (
                  <div key={catKey} className="mobile-cat-group">
                    <div className="mobile-cat-item" onClick={() => setExpandedMobileCat(isExpanded ? null : catKey)}>
                      <span>{catData.icon} {catKey}</span>
                      <span className="arrow">{isExpanded ? '▼' : '▶'}</span>
                    </div>
                    {isExpanded && (
                      <div className="mobile-sub-accordion">
                        {catData.columns.map((col, idx) => (
                          <div key={idx} className="mobile-sub-col">
                            <h5>{col.title}</h5>
                            <ul>
                              {col.items.map((item, i) => (
                                <li key={i} onClick={toggleDrawer}>
                                  <Link to={`/products?department=${encodeURIComponent(catKey)}&Megamenu_Heading=${encodeURIComponent(col.title)}&Sub_ategory=${encodeURIComponent(item)}`}>
                                    {item}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="mobile-menu-list">
              <div className="m-menu-item" onClick={() => { navigate("/category?heading=refurbished"); toggleDrawer(); }}>♻️ Refurbished Products</div>
              <div className="m-menu-item" onClick={toggleDrawer}>📍Service Location</div>
              <div className="m-menu-item" onClick={() => { navigate("/login"); toggleDrawer(); }}>👤 My Account</div>
              <div className="m-menu-item" onClick={() => { navigate("/cart"); toggleDrawer(); }}>🛒 My Cart</div>
            </div>
          )}
        </div>
      </div>

      <div className="mp-top-bar">
        <button className="mp-mobile-menu-btn" onClick={toggleDrawer}>☰</button>
        <div className="logo"><img src={logo} alt="logo" onClick={() => navigate("/")} /></div>
        <div className="mp-power">Powered by <span className="ncn-text"><div className="NCNlogo"><img src={NCNlogo} alt="logo" /></div></span></div>
        <div className="mp-mobile-profile" onClick={() => navigate("/login")}>👤</div>
      </div>

      <div className="mp-nav-main">
        <button className="mp-cat-btn" onClick={toggleDrawer}><span className="hamburger">☰</span> All Categories</button>
        <div className="mp-search-box">
          <select 
            className="mp-select"
            value={selectedDept}
            onChange={(e) => setSelectedDept(e.target.value)}
          >
            <option>All Departments</option>
            {Object.keys(megaMenuData).map(cat => <option key={cat}>{cat}</option>)}
          </select>
          <input 
            type="text" 
            placeholder="Search for products, brands and more..." 
            className="mp-input" 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          />
          <button className="mp-search-btn" onClick={handleSearch}>🔍</button>
        </div>
        <div className="mp-quick-links">
          <div className="mp-link-item">📍Service Location</div>
          <div className="mp-link-item" onClick={() => navigate("/category?heading=refurbished")}>♻️ Refurbished</div>
          <div className="mp-link-item" onClick={() => navigate("/login")}>👤 <span>Login</span></div>
          <div className="mp-link-item mp-cart" onClick={() => navigate("/cart")}>🛒 <span>My Cart</span></div>
        </div>
      </div>

      <div className="mp-categories-container" onMouseLeave={() => setActiveCategory(null)}>
        <div className="mp-categories-bar">
          {Object.keys(megaMenuData).map(catKey => (
            <div key={catKey} className="cat-item" onMouseEnter={() => setActiveCategory(catKey)}>
              {megaMenuData[catKey].icon} {catKey} ▾
            </div>
          ))}
        </div>

        {activeCategory && megaMenuData[activeCategory] && (
          <div className="mp-mega-menu">
            <div className="mega-menu-content">
              <div className="mega-menu-main-section">
                <div className="mega-menu-columns">
                  {megaMenuData[activeCategory].columns.map((col, index) => (
                    <div className="mega-column" key={index}>
                      <h4>{col.title.toUpperCase()}</h4>
                      <ul>
                        {col.items.map((item, i) => (
                          <li key={i}>
                            <Link to={`/products?department=${encodeURIComponent(activeCategory)}&Megamenu_Heading=${encodeURIComponent(col.title)}&Sub_Category=${encodeURIComponent(item)}`}>
                              {item}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;